<footer>
  <div class="containerExterno">
    <p><span>© Copyright - Grupo Casas Bahia S/A</span> <span class="traco"> - </span> <span> Todos os direitos reservados.
      </span></p>
    <a (click)="scrollTop()">TOPO<span class="material-icons">
        expand_less
      </span></a>
  </div>
</footer>
